export const authWhiteList = ["/app/v1/commonWords/queryTitle"];
